"use strict";
exports.__esModule = true;
exports.MerchantCustomerOrderBuilder = exports.MerchantCustomerOrderType = exports.MerchantCustomerOrderState = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var MerchantCustomerOrderState;
(function (MerchantCustomerOrderState) {
    MerchantCustomerOrderState["NEW"] = "NEW";
    MerchantCustomerOrderState["IN_PRODUCTION"] = "IN_PRODUCTION";
    MerchantCustomerOrderState["SHIPPED"] = "SHIPPED";
    MerchantCustomerOrderState["CANCELED"] = "CANCELED";
    MerchantCustomerOrderState["REJECTED"] = "REJECTED";
    MerchantCustomerOrderState["COMPLETED"] = "COMPLETED";
})(MerchantCustomerOrderState = exports.MerchantCustomerOrderState || (exports.MerchantCustomerOrderState = {}));
var MerchantCustomerOrderType;
(function (MerchantCustomerOrderType) {
    MerchantCustomerOrderType["SHOPIFY"] = "SHOPIFY";
})(MerchantCustomerOrderType = exports.MerchantCustomerOrderType || (exports.MerchantCustomerOrderType = {}));
var MerchantCustomerOrderBuilder = /** @class */ (function () {
    function MerchantCustomerOrderBuilder(merchantCustomerOrder) {
        this.merchantCustomerOrder = merchantCustomerOrder;
    }
    MerchantCustomerOrderBuilder.initialiseWithMerchantCustomerOrder = function (merchantCustomerOrder) {
        return new MerchantCustomerOrderBuilder(merchantCustomerOrder);
    };
    MerchantCustomerOrderBuilder.initialiseWithShopOrder = function (merchantPartyId, merchantChannelId, type, shopOrder) {
        switch (type) {
            case MerchantCustomerOrderType.SHOPIFY: return MerchantCustomerOrderBuilder.initialiseWithShopifyOrder(merchantPartyId, merchantChannelId, shopOrder.shopify);
            default: throw new core_common_domain_1.Exception("Cannot create a merchant customer order for type " + type);
        }
    };
    MerchantCustomerOrderBuilder.initialiseWithShopifyOrder = function (merchantPartyId, merchantChannelId, shopifyOrder) {
        return new MerchantCustomerOrderBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            state: MerchantCustomerOrderState.NEW,
            type: MerchantCustomerOrderType.SHOPIFY,
            merchantPartyId: merchantPartyId,
            merchantChannelId: merchantChannelId,
            shopOrderId: shopifyOrder.id,
            shopOrder: {
                shopify: shopifyOrder
            },
            createdAt: shopifyOrder.createdAt,
            updatedAt: shopifyOrder.updatedAt
        });
    };
    MerchantCustomerOrderBuilder.prototype.getId = function () {
        return this.merchantCustomerOrder.id;
    };
    MerchantCustomerOrderBuilder.prototype.withId = function (id) {
        this.merchantCustomerOrder.id = id;
        return this;
    };
    MerchantCustomerOrderBuilder.prototype.getState = function () {
        return this.merchantCustomerOrder.state;
    };
    MerchantCustomerOrderBuilder.prototype.withState = function (state, note) {
        if (note === void 0) { note = ""; }
        this.merchantCustomerOrder.state = state;
        return this;
    };
    MerchantCustomerOrderBuilder.prototype.build = function () {
        return this.merchantCustomerOrder;
    };
    MerchantCustomerOrderBuilder.prototype.buildUpdate = function () {
        return {
            state: this.merchantCustomerOrder.state,
            type: this.merchantCustomerOrder.type,
            merchantPartyId: this.merchantCustomerOrder.merchantPartyId,
            merchantChannelId: this.merchantCustomerOrder.merchantChannelId,
            shopOrderId: this.merchantCustomerOrder.shopOrderId,
            shopOrder: this.merchantCustomerOrder.shopOrder
        };
    };
    return MerchantCustomerOrderBuilder;
}());
exports.MerchantCustomerOrderBuilder = MerchantCustomerOrderBuilder;
